import { api } from "@/lib/api";

// Convert a base64url VAPID public key (string) into the Uint8Array the
// PushManager API expects.
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const out = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) out[i] = rawData.charCodeAt(i);
  return out;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) throw new Error("Service workers unsupported in this browser");
  const reg = await navigator.serviceWorker.register("/admin-sw.js", { scope: "/admin/" });
  if (reg.installing) {
    await new Promise((res) => {
      reg.installing.addEventListener("statechange", (e) => {
        if (e.target.state === "activated" || e.target.state === "installed") res();
      });
    });
  }
  return reg;
}

export async function enableAdminPush() {
  if (!("Notification" in window)) throw new Error("This browser does not support notifications");
  if (!("PushManager" in window)) throw new Error("This browser does not support Web Push");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was not granted");

  const reg = await registerServiceWorker();
  const { data: keyData } = await api.get("/admin/push/vapid-key");
  const applicationServerKey = urlBase64ToUint8Array(keyData.public_key);

  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });
  }
  await api.post("/admin/push/subscribe", {
    subscription: subscription.toJSON(),
    user_agent: navigator.userAgent,
  });
  return subscription;
}

export async function disableAdminPush() {
  const reg = await navigator.serviceWorker.getRegistration("/admin/");
  if (!reg) return;
  const subscription = await reg.pushManager.getSubscription();
  if (subscription) {
    try {
      await api.post("/admin/push/unsubscribe", { endpoint: subscription.endpoint });
    } catch {
      /* ignore */
    }
    await subscription.unsubscribe();
  }
}

export async function isAdminPushActive() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  const reg = await navigator.serviceWorker.getRegistration("/admin/");
  if (!reg) return false;
  const subscription = await reg.pushManager.getSubscription();
  return !!subscription;
}
